var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('PriceArea',{attrs:{"catalog":_vm.catalog,"edit":_vm.edit,"submit":_vm.submit,"list-uom":_vm.listUom,"flag":_vm.flag,"model":_vm.model},on:{"handleEdit":function($event){return _vm.$emit('handleEdit')},"setPriceArea":(e) => _vm.$emit('setPriceArea', e)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }